import React from "react";
import s from "./styles.scss";
import { Preview } from "../../../types/IAction";
import {
  Expediente,
  RequestArchivo,
  Archivo,
  StatusAutorizacion,
  CreateDocumentLinkRequest
} from "../expedientsV2controls/types";
import { Styled, ReduxConnect } from "../../../toolkit/decorators/Artifact";
import ArchivoControl from "../expedientsV2controls/archivo/archivo";
import * as actions from "../../actions/expedientes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { catFormConfig } from "./cat.form";
import {
  successNotification,
  errorNotification
} from "../../../utils/notifications";
import {
  getExpedienteFimasCompletas,
  activate,
  enableForPaymentsStatus
} from "../../actions/partners";
import { representanteFormConfig } from "./representante.form";
import { getPersonByIdRequest } from "../../actions/persons";
import IFrameModal from "../common/iframeModal/iFrameModal";
import { throws } from "assert";
import ModalFrame from "../../../toolkit/modalFrame";
import { Container, Row, Col, Button } from "reactstrap";
import DocumentoInvalidoModal from "../../containers/personaReferencia/documentoInvalido";

const mapDispatchToProps = dispatch => ({
  getExpedienteFromMembresia: (idExpediente): Promise<Preview<any>> => {
    return dispatch(actions.getExpedienteFromMembresia(idExpediente));
  },
  postRefresh: (requestArchivo: RequestArchivo): Promise<Preview<any>> => {
    return dispatch(actions.postRefresh(requestArchivo));
  },
  postEnvioCorreo: (idExpediente, idItem): Promise<Preview<any>> => {
    return dispatch(actions.postEnvioCorreo(idExpediente, idItem));
  },
  putCincelFirmas: (idExpediente, idItem): Promise<Preview<any>> => {
    return dispatch(actions.putCincelFirmas(idExpediente, idItem));
  },
  getArchivoVigente: (idExpediente, idDocumento): Promise<Preview<any>> => {
    return dispatch(actions.getArchivoVigente(idExpediente, idDocumento));
  }
});

const mapStateToProps = state => {
  const { expedientes, user } = state;

  return {
    expedienteMembresia: expedientes.expedienteMembresia,
    expedienteMembresiaLoading: expedientes.expedienteMembresiaLoading,
    archivoRefreshLoading: expedientes.archivoRefreshLoading,
    cincelFirmasLoading: expedientes.cincelFirmasLoading,
    userContext: user.userContext
  };
};

interface Props {
  // Datos del expediente y sus archivos
  expedienteMembresia?: Expediente;
  expedienteMembresiaLoading?: boolean;
  archivoRefreshLoading?: boolean;
  cincelFirmasLoading?: boolean;
  userContext: any;

  // Actions del expediente
  getExpedienteFromMembresia?: (idExpediente) => Promise<Preview<any>>;
  postRefresh?: (requestArchivo: RequestArchivo) => Promise<Preview<any>>;
  postEnvioCorreo?: (idExpediente, idItem) => Promise<Preview<any>>;
  putCincelFirmas?: (idExpediente, idItem) => Promise<Preview<any>>;
  getArchivoVigente?: (idExpediente, idDocumento) => Promise<Preview<any>>;
  refreshPartner: () => void;

  idMembresiaSocio: any;

  // Indica si la membresía fue traspasada
  descripcionTraspaso: any;
  membershipBlocked: boolean;

  // Indica si la membresía está en proceso de venta
  procesoVenta: boolean;
}

interface State {
  waiting: boolean;
  archivos: Archivo[][];

  iFrameModalIsOpen: boolean;
  iFrameModalSrc: string;
  iFrameModalArchiveData: Archivo;

  showFirmanteSelector: boolean;
  firmantes: any[];
  archivoFirmaOnline: Archivo;

  isDocumentoInvalidoOpen: boolean;
  documentoInvalidoData: {
    storage: string;
    resolucion: boolean;
    razonamiento: string;
    nombre: string;
  };
}

/**
 * Tabla del módulo de expedientes
 */
@ReduxConnect(mapStateToProps, mapDispatchToProps)
@Styled(s)
export default class ExpedienteTabla extends React.Component<Props, State> {
  state = {
    waiting: false,
    archivos: [],
    iFrameModalIsOpen: false,
    iFrameModalSrc: null,
    iFrameModalArchiveData: null,
    showFirmanteSelector: false,
    firmantes: null as any[],
    archivoFirmaOnline: null as Archivo,
    isDocumentoInvalidoOpen: false,
    documentoInvalidoData: null
  };

  componentDidMount(): void {
    if (this.props.idMembresiaSocio) {
      this.props.getExpedienteFromMembresia(this.props.idMembresiaSocio);
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>): void {
    if (this.props.idMembresiaSocio != prevProps.idMembresiaSocio) {
      this.props.getExpedienteFromMembresia(this.props.idMembresiaSocio);
    }

    // Se activa la animación de carga, cuando se está actualizando el expediente
    if (
      this.props.expedienteMembresiaLoading !=
        prevProps.expedienteMembresiaLoading ||
      this.props.archivoRefreshLoading != prevProps.archivoRefreshLoading ||
      this.props.cincelFirmasLoading != prevProps.cincelFirmasLoading
    ) {
      this.setState({
        waiting:
          this.props.expedienteMembresiaLoading ||
          this.props.archivoRefreshLoading ||
          this.props.cincelFirmasLoading
      });
    }

    // Si se actualiza el expediente correctamente, se ordenan los archivos
    if (
      this.props.expedienteMembresia != prevProps.expedienteMembresia &&
      this.props.expedienteMembresia.vigentes
    ) {
      this.setState({
        archivos: this.ordenarArchivos()
      });
    }
  }

  sendEmail = async (archivo: Archivo) => {
    const preview = await this.props.postEnvioCorreo(
      archivo.idExpediente,
      archivo.idItem
    );
    return preview;
  };

  regenerar = async (archivo: Archivo, values?: any) => {
    const requestArchivo: RequestArchivo = {
      codigo: archivo.codigo,
      idMembresiaSocio: this.props.idMembresiaSocio,
      idPersonaExpediente: null,
      idMembresiaSocioPersona: archivo.idMembresiaSocioPersona,
      idPersonaDocumento: archivo.idPersona,
      idMedioPago: archivo.idMedioPago,
      idCotizacionItem: archivo.idCotizacionItem,
      idPersonaEvaluacion: archivo.idPersonaEvaluacion,
      values
    };

    const preview = await this.props.postRefresh(requestArchivo);

    if (preview.fulfilled) {
      await this.props.getExpedienteFromMembresia(this.props.idMembresiaSocio);
    }

    return preview;
  };

  update = async (archivo: Archivo) => {
    // Verificar si es un documento de identificación
    const esIdentificacion =
      archivo.codigo === "IDENTIFICACION" ||
      archivo.codigo === "IDENTIFICACION_INTEGRANTE";

    if (esIdentificacion) {
      // Obtener el archivo vigente para verificar la validación de identificación
      const archivoVigentePreview = await this.props.getArchivoVigente(
        archivo.idExpediente,
        archivo.idDocumento
      );

      if (
        archivoVigentePreview.fulfilled &&
        archivoVigentePreview.archivoVigente
      ) {
        const archivoVigente = archivoVigentePreview.archivoVigente;

        // Verificar si existe evaluación de identificación y si la resolución es falsa
        if (
          archivoVigente.verificacionIdentificacion &&
          archivoVigente.verificacionIdentificacion.resolucion === false
        ) {
          // Mostrar popup de documento inválido
          this.setState({
            isDocumentoInvalidoOpen: true,
            documentoInvalidoData: {
              storage: archivoVigente.storage,
              resolucion: false,
              razonamiento:
                archivoVigente.verificacionIdentificacion.razonamiento ||
                "El documento de identificación no es válido",
              nombre: archivo.nombre
            }
          });

          await this.props.getExpedienteFromMembresia(
            this.props.idMembresiaSocio
          );

          // No continuar con el flujo normal si el documento es inválido
          return archivoVigentePreview;
        }
      }
    }

    const result = await this.props.getExpedienteFromMembresia(
      this.props.idMembresiaSocio
    );

    const { data } = await getExpedienteFimasCompletas(
      this.props.idMembresiaSocio
    );

    if (!!data && !!data.body) {
      await enableForPaymentsStatus(this.props.idMembresiaSocio);

      if (!!this.props.refreshPartner) {
        this.props.refreshPartner();
      }
    }

    return result;
  };

  cincelFirma = async (archivo: Archivo) => {
    if (archivo.statusAutorizacion == StatusAutorizacion.NO_GENERADO) {
      errorNotification(
        "Debe generar el documento antes de verificar las firmas"
      );

      return {
        fulfilled: false
      };
    }

    const preview = await this.props.putCincelFirmas(
      archivo.idExpediente,
      archivo.idItem
    );

    if (preview.fulfilled) {
      successNotification("El documento firmado se obtuvo correctamente");
      await this.props.getExpedienteFromMembresia(this.props.idMembresiaSocio);
    }

    const { data } = await getExpedienteFimasCompletas(
      this.props.idMembresiaSocio
    );

    if (!!data && !!data.body) {
      await enableForPaymentsStatus(this.props.idMembresiaSocio);

      if (!!this.props.refreshPartner) {
        this.props.refreshPartner();
      }
    }

    return preview;
  };

  firmarOnline = async (archivo: Archivo) => {
    if (archivo.completo) {
      errorNotification("El documento ya se encuentra firmado.");
      return;
    }

    try {
      const { data } = await actions.getCincelDocumentFirmantes(
        archivo.idExpediente,
        archivo.idItem
      );

      const firmantes = ((data || {}).firmantes || []).reverse();

      if (!firmantes || firmantes.length <= 0) {
        errorNotification("No se encontraron firmantes para el documento.");
      } else if (firmantes.length == 1) {
        // Si solo hay un firmante, se firma directamente
        await this.firmarOnlineFirmante(firmantes[0], archivo);
      } else {
        // Si hay más de un firmante, se muestra el selector
        this.setState({
          showFirmanteSelector: true,
          firmantes,
          archivoFirmaOnline: archivo
        });
      }
    } catch (error) {
      errorNotification(
        error && error.response && error.response.data
          ? error.response.data.message || "Error al obtener firmantes"
          : "Error al obtener firmantes"
      );
    }
  };

  firmarOnlineFirmante = async (firmante: any, archivo: Archivo) => {
    try {
      //Se obtienen la info de los firmantes del documento
      console.info("Archivo: ", archivo);

      const archivoPersonaId = archivo.idPersona || archivo.idOwner || null;

      const { data: personaResult } = await getPersonByIdRequest(
        archivoPersonaId
      );
      if (!personaResult) {
        errorNotification("La persona asociada al documento no existe");
        return;
      }

      if ((personaResult.curp || "").length <= 0) {
        errorNotification(
          "La persona no cuenta con un curp válido y registrado"
        );
        return;
      }

      const createCincelDocumentLinkRequest: CreateDocumentLinkRequest = {
        idExpediente: archivo.idExpediente,
        idItem: archivo.idItem,
        idPersona: firmante.idPersona,
        firmanteUuid: firmante.firmanteUuid,
        documentoUuid: firmante.documentoUuid,
        curp: firmante.curp || personaResult.curp || null,
        email: firmante.email,
        nombre: firmante.nombre
      };

      console.info(
        "CreateDocumentLinkRequest: ",
        createCincelDocumentLinkRequest
      );

      const { data: createLinkResult } = await actions.createCincelDocumentLink(
        createCincelDocumentLinkRequest
      );
      console.info("Create link result: ", createLinkResult);
      if (!!createLinkResult && !!createLinkResult.url) {
        //window.open(createLinkResult.url, "_blank");
        this.setState({
          iFrameModalIsOpen: true,
          iFrameModalSrc: createLinkResult.url,
          iFrameModalArchiveData: archivo
        });
        return;
      }
    } catch (error) {
      errorNotification("Error al abrir documento para firma.");
      this.setState({
        iFrameModalIsOpen: false,
        iFrameModalSrc: null,
        iFrameModalArchiveData: null
      });
    }
  };

  ordenarArchivos() {
    const hash: any = {};
    const ordenados = [];

    // Se separan los expedientes por usuario
    for (const archivo of this.props.expedienteMembresia.vigentes) {
      if (hash[archivo.idOwner]) {
        hash[archivo.idOwner].push(archivo);
      } else {
        hash[archivo.idOwner] = [archivo];
      }
    }

    // Se concentran los expedientes por usuario en una lista
    for (const archivosKey in hash) {
      ordenados.push(hash[archivosKey]);
    }

    return ordenados;
  }

  isMembershipBlocked = () => {
    return this.props.membershipBlocked || false;
  };

  closeDocumentoInvalido = () => {
    this.setState({
      isDocumentoInvalidoOpen: false,
      documentoInvalidoData: null
    });
  };

  render() {
    // Si no se han cargado o actualizado los documentos, se muestra la animación
    const className =
      this.state.waiting || !this.props.expedienteMembresia.vigentes
        ? `${s.expedient} ${s.waiting}`
        : s.expedient;

    return (
      <div className={className}>
        <div className={s.spinner}>
          <FontAwesomeIcon icon={faSpinner} pulse />
        </div>

        {this.state.archivos.map(this.renderTable)}
        {this.renderFirmanteSelector()}
        {this.state.documentoInvalidoData && (
          <DocumentoInvalidoModal
            isOpen={this.state.isDocumentoInvalidoOpen}
            onClose={this.closeDocumentoInvalido}
            storage={this.state.documentoInvalidoData.storage}
            resolucion={this.state.documentoInvalidoData.resolucion}
            razonamiento={this.state.documentoInvalidoData.razonamiento}
            nombre={this.state.documentoInvalidoData.nombre}
          />
        )}
      </div>
    );
  }

  renderTable = (archivos: Archivo[]) => {
    const archivosPorMostrar: Archivo[] = this.isMembershipBlocked()
      ? (archivos || []).filter(archivo => archivo.completo)
      : archivos;

    if (!archivosPorMostrar.length) {
      return <></>;
    }

    const nombre = `${archivos[0].nombreCompleto} (${archivos[0].idOwner})`;
    return (
      <>
        <IFrameModal
          isOpen={this.state.iFrameModalIsOpen}
          title={"Firma de documento"}
          okTitle={"Procesar firmas"}
          ok={() => {
            const { iFrameModalArchiveData } = this.state;
            this.cincelFirma({ ...iFrameModalArchiveData });
            this.setState({
              iFrameModalSrc: null,
              iFrameModalIsOpen: false,
              iFrameModalArchiveData: null
            });
          }}
          cancel={() => {
            this.setState({
              iFrameModalSrc: null,
              iFrameModalIsOpen: false,
              iFrameModalArchiveData: null
            });
          }}
          src={this.state.iFrameModalSrc}
        />

        <div className={s.ownerName}>{nombre}</div>
        {archivosPorMostrar.map(archivo => {
          const codigo = archivo.codigo;
          let formConfig = null;
          let init = null;

          // Casos especiales
          if (codigo == "ALTA_CAT" || codigo == "CINCEL_ALTA_CAT") {
            formConfig = catFormConfig;
          } else if (codigo == "CINCEL_TRASPASO_MEMBRESIA") {
            const user = this.props.userContext;
            formConfig = representanteFormConfig;
            init = user
              ? {
                  nombre: `${user.name || ""} ${user.firstSurname ||
                    ""} ${user.secondSurname || ""}`
                    .toUpperCase()
                    .trim(),
                  correo: user.email || ""
                }
              : null;
          }

          return (
            <ArchivoControl
              key={"archivo-item-" + archivo.idItem}
              archivo={archivo}
              userId={0}
              sendEmail={this.sendEmail}
              regenerar={this.regenerar}
              formConfigRegenerar={formConfig}
              formConfigInit={init}
              update={() => this.update(archivo)}
              botonCorreo={!this.isMembershipBlocked()}
              botonFirmaOEscanner={!this.isMembershipBlocked()}
              botonRegenrar={!this.isMembershipBlocked()}
              botonFirmarOnline={!this.isMembershipBlocked()}
              cincelFirma={this.cincelFirma}
              firmarOnline={this.firmarOnline}
              procesoVenta={this.props.procesoVenta}
            />
          );
        })}
      </>
    );
  };

  renderFirmanteSelector = () => {
    if (!this.state.firmantes) {
      return null;
    }

    const archivo = this.state.archivoFirmaOnline;

    return (
      <ModalFrame
        title={"Seleccionar firmante"}
        isOpen={this.state.showFirmanteSelector}
        toggle={() => this.setState({ showFirmanteSelector: false })}
        size="md"
      >
        <Container style={{ width: "90%" }} className="center-block p-0 mb-3">
          <Row>
            <div
              style={{
                backgroundColor: "#eee",
                fontSize: "11px",
                fontWeight: "bold",
                padding: "4px",
                width: "100%",
                textAlign: "center"
              }}
            >
              Recuerde que las firmas deben solicitarse en cierto orden.
            </div>
          </Row>
          {this.state.firmantes.map(firmante => (
            <Row key={firmante.firmanteUuid} className="mt-2 mb-3">
              <Col xs="12" md="12">
                <div
                  style={{
                    padding: "4px",
                    borderRadius: "5px",
                    backgroundColor: "#fff2cc"
                  }}
                >
                  Firmante: {firmante.nombre}
                  <br />
                  <span style={{ fontSize: "12px" }}>{firmante.email}</span>
                </div>
              </Col>
              <Col xs="12" md="12">
                <Button
                  className={`${s.secundaryButton} mt-3`}
                  onClick={() => {
                    this.firmarOnlineFirmante(firmante, archivo);
                    this.setState({ showFirmanteSelector: false });
                  }}
                  block
                  disabled={this.state.waiting || archivo.completo}
                >
                  Firmar
                </Button>
              </Col>
              <Col xs="12" md="12">
                <hr />
              </Col>
            </Row>
          ))}

          <Row className="mt-2">
            <Col xs="12" md="12">
              <Button
                className={`${s.secundaryButton} mt-3`}
                onClick={() => {
                  this.setState({ showFirmanteSelector: false });
                }}
                block
                disabled={this.state.waiting}
              >
                Cancelar
              </Button>
            </Col>
          </Row>
        </Container>
      </ModalFrame>
    );
  };
}
